import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {
    ADMINISTRATION_MANAGE_LINKAGES,
    ADMINISTRATION_MANAGE_TECH_OBJECTS,
    ADMINISTRATION_MANAGE_USERS,
    MAINTENANCE_BI_TOOLS,
    REPORTING_AD_HOC_BUILDER,
} from './Shared/AuthCapabilityHelper';
import CapabilityGuardedRoute from './CapabilityGuardedRoute';
import GuardedRoute from './GuardedRoute';
import Home from './Home/Home';
import { 
    Online, 
    registerAgGrid, 
    ClientSideRowModelModule, 
    CsvExportModule, 
    ExcelExportModule, 
    ColumnsToolPanelModule, 
    FiltersToolPanelModule, 
    MenuModule, 
    MultiFilterModule, 
    RangeSelectionModule,
    RowGroupingModule,
    SetFilterModule,
    SideBarModule,
    ClipboardModule,
    GridChartsModule,
    SparklinesModule,
    StatusBarModule 
} from '@servahealth/serva-ui-kit';
import LoginPage from '../Components/Login/LoginPage';
import AuthenticationContextProvider from '../Auth/Auth';
import AUDChart from './Admin/AUDChart';
import AUDDataSet from './Admin/AUDDataSet';
import AUDFTPServer from './Admin/AUDFTPServer';
import AUDReport from './Admin/AUDReport';
import AUDTenant from './Admin/AUDTenant';
import AUDUser from './Admin/AUDUser';
import AdminUser from './Admin/AdminUser';
import AdminReport from './Admin/AdminReport';
import AdminTenant from './Admin/AdminTenant';
import AdHocReportBuilder from './Admin/AdHocReportBuilder';
import RetainBIMaintenance from './Admin/RetainBIMaintenance';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-balham.css';
import './App.css';
import AppShell from './AppShell/AppShell';

const queryClient = new QueryClient();

registerAgGrid(process.env.REACT_APP_AG_GRID_LICENSE ?? '', [
    ClientSideRowModelModule, 
    CsvExportModule, 
    ExcelExportModule, 
    ColumnsToolPanelModule, 
    FiltersToolPanelModule, 
    MenuModule, 
    MultiFilterModule, 
    RangeSelectionModule,
    RowGroupingModule,
    SetFilterModule,
    SideBarModule,
    ClipboardModule,
    GridChartsModule,
    SparklinesModule,
    StatusBarModule
]);

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <Online />
            <Router>
                <AuthenticationContextProvider>
                    <Routes>
                        <Route path="/" element={<LoginPage />} />
                        <Route element={<GuardedRoute><AppShell /></GuardedRoute>}>
                            <Route path="/home/:reportId?" element={<Home />} />
                            <Route path="/audCharts" element={<CapabilityGuardedRoute capability={ADMINISTRATION_MANAGE_TECH_OBJECTS}><AUDChart /></CapabilityGuardedRoute>} />
                            <Route path="/audDataSets" element={<CapabilityGuardedRoute capability={ADMINISTRATION_MANAGE_TECH_OBJECTS}><AUDDataSet /></CapabilityGuardedRoute>} />
                            <Route path="/audFTPServers" element={<CapabilityGuardedRoute capability={ADMINISTRATION_MANAGE_TECH_OBJECTS}><AUDFTPServer /></CapabilityGuardedRoute>} />
                            <Route path="/audReports" element={<CapabilityGuardedRoute capability={ADMINISTRATION_MANAGE_TECH_OBJECTS}><AUDReport /></CapabilityGuardedRoute>} />
                            <Route path="/audTenants" element={<CapabilityGuardedRoute capability={ADMINISTRATION_MANAGE_TECH_OBJECTS}><AUDTenant /></CapabilityGuardedRoute>} />
                            <Route path="/audUsers" element={<CapabilityGuardedRoute capability={ADMINISTRATION_MANAGE_USERS}><AUDUser /></CapabilityGuardedRoute>} />
                            <Route path="/adminUsers" element={<CapabilityGuardedRoute capability={ADMINISTRATION_MANAGE_LINKAGES}><AdminUser /></CapabilityGuardedRoute>} />
                            <Route path="/adminReports" element={<CapabilityGuardedRoute capability={ADMINISTRATION_MANAGE_LINKAGES}><AdminReport /></CapabilityGuardedRoute>} />
                            <Route path="/adminTenants" element={<CapabilityGuardedRoute capability={ADMINISTRATION_MANAGE_LINKAGES}><AdminTenant /></CapabilityGuardedRoute>} />
                            <Route path="/ahReportBuilder" element={<CapabilityGuardedRoute capability={REPORTING_AD_HOC_BUILDER}><AdHocReportBuilder /></CapabilityGuardedRoute>} />
                            <Route path="/retainBIMaintenance" element={<CapabilityGuardedRoute capability={MAINTENANCE_BI_TOOLS}><RetainBIMaintenance /></CapabilityGuardedRoute>} />
                        </Route>
                    </Routes>
                </AuthenticationContextProvider>
            </Router>
        </QueryClientProvider>
    );
}

export default App;
